/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from '../utils/axiosInstance';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import { Buffer } from 'buffer';
import { toast } from 'react-hot-toast';
import {
  FiUser, FiClock, FiCheckCircle, FiBookOpen, FiList,
  FiUpload, FiLogOut, FiAlertCircle, FiHeart, FiTarget,
  FiCalendar, FiLink, FiEdit2, FiStar,
  FiGrid, FiExternalLink, FiTrash2, FiCamera, FiMessageSquare, FiSend,
  FiMessageCircle, FiRefreshCw, FiGift, FiBell, FiPlus, FiBarChart2,
  FiGlobe, FiMapPin, FiPhone, FiMail, FiAward, FiBriefcase
} from 'react-icons/fi';
import SiteNavbar from '../components/SiteNavbar';
import CompleteProfileModal from '../components/CompleteProfileModal';
import MojiChatbot from '../components/MojiChatbot';
import IntakeChatPanel from '../components/IntakeChatPanel';
import recService from '../Services/RecService';
import { claimGuestChat, hasGuestChat } from '../utils/guestChat';
import LearningIdentityModal from '../components/LearningIdentityModal';

const TAB_KEYS = ['overview', 'edubuddy', 'profile', 'goals', 'courses', 'messages'];

// ─── Brand Colors ─────────────────────────────────────────────────────────────
const brand = {
  primary: 'var(--primary-color)',
  primaryDark: 'var(--primary-color-dark)',
  secondary: 'var(--secondary-color)',
  secondaryDark: 'var(--secondary-color-dark)',
  backgroundLight: 'var(--bg-light)',
  backgroundWhite: 'var(--bg-white)',
  text: 'var(--text-primary)',
  textSub: 'var(--text-secondary)',
  white: '#ffffff',
  greyLight: 'var(--border-color)',
  greyMid: '#ced4da',
  success: '#28a745',
  warning: '#fd7e14',
  danger: '#dc3545',
};

// ─── Static data ──────────────────────────────────────────────────────────────
const LEARNING_GOALS = [
  'Get a new job', 'Upskill in current role', 'Start a business',
  'Learn a new skill', 'Get certified', 'Switch careers',
  'Improve digital literacy', 'Build a portfolio', 'Freelancing',
];

const INTERESTS = [
  // Technology & Engineering
  'Web Development', 'Mobile Development', 'Backend Development', 'Frontend Development',
  'Full-Stack Development', 'DevOps', 'Cloud Computing', 'Cybersecurity',
  'Data Science', 'Machine Learning', 'Artificial Intelligence', 'Deep Learning',
  'Data Engineering', 'Data Analytics', 'Business Intelligence', 'Database Administration',
  'Blockchain', 'Web3 & Smart Contracts', 'Embedded Systems', 'Robotics',
  'Game Development', 'AR/VR Development', 'API Development', 'Microservices',
  // Design & Creative
  'UI/UX Design', 'Graphic Design', 'Motion Graphics', 'Video Editing',
  'Photography', 'Illustration', 'Brand Design', '3D Modelling',
  // Business & Management
  'Product Management', 'Project Management', 'Agile & Scrum', 'Business Analysis',
  'Entrepreneurship', 'Finance & Accounting', 'Supply Chain Management',
  'Human Resources', 'Sales & CRM', 'Legal & Compliance',
  // Marketing & Communication
  'Digital Marketing', 'Content Creation', 'SEO & SEM', 'Social Media Marketing',
  'Email Marketing', 'Copywriting', 'Public Relations', 'Community Management',
  // Personal & Professional Development
  'Leadership', 'Communication Skills', 'Critical Thinking', 'Time Management',
  'Foreign Languages', 'Research & Academia',
];

const INDUSTRIES = [
  'Technology', 'Finance', 'Healthcare', 'Education', 'E-commerce',
  'Media & Entertainment', 'Agriculture', 'Government', 'NGO/Non-profit',
  'Manufacturing', 'Telecoms', 'Consulting',
];

const AFRICAN_COUNTRIES = [
  'Algeria', 'Angola', 'Benin', 'Botswana', 'Burkina Faso', 'Burundi',
  'Cabo Verde', 'Cameroon', 'Chad', 'Democratic Republic of the Congo', 'Egypt',
  'Ethiopia', 'Ghana', 'Guinea', 'Ivory Coast', 'Kenya', 'Libya', 'Madagascar',
  'Malawi', 'Mali', 'Mauritania', 'Morocco', 'Mozambique', 'Namibia', 'Niger',
  'Nigeria', 'Rwanda', 'Senegal', 'Sierra Leone', 'Somalia', 'South Africa',
  'South Sudan', 'Sudan', 'Tanzania', 'Togo', 'Tunisia', 'Uganda', 'Zambia', 'Zimbabwe',
];

// ─── Styled Components ────────────────────────────────────────────────────────
// Font comes from the design system base layer (Manrope); this only sets the
// dashboard's surface treatment.
const GlobalStyle = createGlobalStyle`body { background-color: ${brand.backgroundLight}; color: ${brand.text}; }`;

const DashboardWrapper = styled.div`display: flex; flex-direction: column; min-height: 100vh;`;

const DashboardContainer = styled(Container)`
  flex: 1;
  padding-top: calc(var(--navbar-height) + 2rem);
  padding-bottom: 4rem;

  @media (max-width: 991.98px) {
    padding-top: calc(var(--navbar-height) + 1.25rem);
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 2.5rem;
  }
`;

const TabNav = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
  border-bottom: 2px solid ${brand.greyLight};
  overflow-x: auto;
  position: sticky;
  top: var(--navbar-height);
  z-index: 400;
  background: ${brand.backgroundLight};
  padding-top: 0.65rem;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar { display: none; }

  @media (max-width: 576px) {
    gap: 0.15rem;
    margin-bottom: 1.25rem;
    margin-left: -12px;
    margin-right: -12px;
    padding-left: 12px;
    padding-right: 12px;
  }
`;

const TabBtn = styled.button`
  background: none;
  border: none;
  border-bottom: 3px solid ${p => p.active ? brand.primary : 'transparent'};
  color: ${p => p.active ? brand.primary : brand.textSub};
  font-weight: ${p => p.active ? 700 : 500};
  font-size: 0.9rem;
  padding: 0.7rem 1.2rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 44px;
  &:hover { color: ${brand.primary}; }

  @media (max-width: 576px) {
    font-size: 0.82rem;
    padding: 0.6rem 0.75rem;
  }
`;

const SubTabNav = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid ${brand.greyLight};
  overflow-x: auto;
  &::-webkit-scrollbar { display: none; }
`;

const SubTabBtn = styled.button`
  background: none;
  border: none;
  border-bottom: 3px solid ${p => p.active ? brand.primary : 'transparent'};
  color: ${p => p.active ? brand.primary : brand.textSub};
  font-weight: ${p => p.active ? 700 : 500};
  font-size: 0.85rem;
  padding: 0.5rem 1rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.3rem;
  &:hover { color: ${brand.primary}; }
`;

const WelcomeHeader = styled.div`
  margin-bottom: 2rem;
  padding: 1.5rem;
  background-color: ${brand.backgroundWhite};
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.05);
  display: flex;
  align-items: center;
  gap: 1.5rem;
  border-left: 5px solid ${brand.primary};
  h1 { font-size: clamp(1.2rem, 2vw + 0.6rem, 1.5rem); font-weight: 600; color: ${brand.text}; margin-bottom: 0.45rem; line-height: 1.3; }
  p { color: ${brand.textSub}; margin-bottom: 0; font-size: 0.9rem; }

  @media (max-width: 576px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.85rem;
    padding: 1.1rem 1rem;
    margin-bottom: 1.25rem;
  }
`;

const CompletenessWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;

  .completeness-head {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    min-width: 0;
  }

  .completeness-label {
    display: flex;
    align-items: center;
    gap: 0.45rem;
    flex-shrink: 0;
  }

  .completeness-bar {
    flex: 1;
    min-width: 0;
    height: 8px;
    border-radius: 8px;
    background: #e9ecef;
    overflow: hidden;
    cursor: pointer;
  }

  .completeness-chips {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    width: 100%;
  }

  .completeness-chip {
    width: 100%;
    justify-content: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 0.85rem;

    .completeness-chips {
      display: flex;
      flex-wrap: wrap;
      width: auto;
      flex: 1;
    }

    .completeness-chip {
      width: auto;
    }
  }
`;

const SummaryCard = styled(Card)`
  border: none; border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.06);
  transition: transform 0.2s, box-shadow 0.2s;
  height: 100%; background: ${brand.backgroundWhite};
  text-align: center; padding: 1.5rem 1rem;
  &:hover { transform: translateY(-5px); box-shadow: 0 6px 20px rgba(0,0,0,0.08); }
  .summary-icon { font-size: 2rem; margin-bottom: 0.75rem; color: ${p => p.iconColor || brand.primary}; }
  .summary-value { font-size: 2.5rem; font-weight: 700; color: ${p => p.valueColor || brand.text}; margin-bottom: 0.2rem; line-height: 1.2; }
  h5 { font-size: 0.9rem; font-weight: 500; color: ${brand.textSub}; margin-bottom: 0; }
`;

const SectionCard = styled(Card)`
  border: none; border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.06);
  background: ${brand.backgroundWhite}; overflow: hidden;
  .card-header {
    background: ${brand.backgroundWhite}; border-bottom: 1px solid ${brand.greyLight};
    font-weight: 600; font-size: 1rem; color: ${brand.text};
    display: flex; align-items: center; gap: 0.75rem; padding: 1rem 1.25rem;
    svg { color: ${brand.primary}; font-size: 1.2rem; }
  }
`;

const StyledListItem = styled(ListGroup.Item)`
  display: flex; align-items: flex-start; gap: 1rem;
  padding: 1rem 1.25rem; background: transparent;
  border-color: ${brand.greyLight} !important;
  border-width: 0 0 1px 0; transition: background 0.15s;
  &:hover { background: ${brand.backgroundLight}; }
  .icon-wrap { margin-top: 0.15rem; color: ${p => p.iconColor || brand.textSub}; font-size: 1.1rem; }
  .content { flex-grow: 1; h6 { font-weight: 600; margin-bottom: 0.2rem; color: ${brand.text}; } p, .text-muted { font-size: 0.82rem; color: ${brand.textSub}; margin-bottom: 0.4rem; } }
`;

const StyledBadge = styled(Badge)`
  font-size: 0.72rem; font-weight: 500; padding: 0.3em 0.6em;
  border-radius: 50px;
  &.bg-paid, &.bg-completed { background: ${brand.success} !important; color: white; }
  &.bg-pending, &.bg-uncompleted { background: ${brand.warning} !important; color: white; }
`;

const StyledModal = styled(Modal)`
  .modal-content { border-radius: 12px; border: none; background: ${brand.backgroundWhite}; box-shadow: 0 10px 30px rgba(0,0,0,0.1); }
  .modal-header { background: ${brand.primary}; color: white; border-radius: 12px 12px 0 0; border-bottom: none; .modal-title { font-weight: 600; } .btn-close { filter: brightness(0) invert(1); } }
  .modal-body { padding: 1.5rem; .form-label { font-weight: 500; color: ${brand.textSub}; } .form-control, .form-select { border-color: ${brand.greyMid}; &:focus { border-color: ${brand.primary}; box-shadow: 0 0 0 0.2rem rgba(89,180,154,0.25); } } }
  .modal-footer { border-top: 1px solid ${brand.greyLight}; padding: 1rem 1.5rem; }
`;

const PrimaryBtn = styled(Button)`
  background: ${brand.primary}; border-color: ${brand.primary}; color: #ffffff !important; border-radius: 50px; font-weight: 500;
  display: inline-flex; align-items: center; gap: 0.4rem;
  &:hover, &:focus, &:active { background: ${brand.primaryDark}; border-color: ${brand.primaryDark}; color: #ffffff !important; }
  &.btn-outline-primary { background: transparent; color: ${brand.primary} !important; border-color: ${brand.primary}; &:hover { background: ${brand.backgroundLight}; color: ${brand.primaryDark} !important; } }
  &.btn-outline-danger { background: transparent; color: ${brand.danger} !important; border-color: ${brand.danger}; &:hover { background: rgba(220,53,69,0.08); color: ${brand.danger} !important; } }
`;

const CourseCard = styled(Card)`
  border: none; border-radius: 12px; box-shadow: 0 2px 10px rgba(0,0,0,0.07);
  transition: transform 0.2s, box-shadow 0.2s; height: 100%; background: ${brand.backgroundWhite};
  &:hover { transform: translateY(-4px); box-shadow: 0 6px 20px rgba(0,0,0,0.1); }
  .card-img-top { height: 150px; object-fit: cover; border-radius: 12px 12px 0 0; }
  .card-body { padding: 1rem; }
  .card-title { font-size: 0.9rem; font-weight: 600; color: ${brand.text}; margin-bottom: 0.5rem; }
  .card-text { font-size: 0.8rem; color: ${brand.textSub}; }
`;

const TagChip = styled.span`
  display: inline-block;
  background: ${p => p.selected ? brand.primary : brand.greyLight};
  color: ${p => p.selected ? '#fff' : brand.text};
  border: 1.5px solid ${p => p.selected ? brand.primary : brand.greyLight};
  border-radius: 50px;
  padding: 0.3rem 0.9rem;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.15s;
  user-select: none;
  &:hover { border-color: ${brand.primary}; color: ${p => p.selected ? '#fff' : brand.primary}; }
`;

const MoreChip = styled(TagChip)`
  background: transparent;
  border-style: dashed;
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-weight: 600;
  color: ${brand.primary};
  &:hover { color: ${brand.primary}; }
`;

const StyledFooter = styled.footer`
  background: ${brand.backgroundWhite}; color: ${brand.textSub};
  text-align: center; padding: 1.5rem 0; font-size: 0.88rem;
  border-top: 1px solid ${brand.greyLight}; margin-top: auto;
`;

const inputStyle = { borderColor: brand.primary, borderRadius: 8 };

// ─── Helpers ─────────────────────────────────────────────────────────────────
// ─── Main Component ───────────────────────────────────────────────────────────
const LearnerDashboard = () => {
  const navigate = useNavigate();

  const handleRequestSponsorship = (course) => {
    navigate('/help', {
      state: {
        course: {
          courseTitle: course.title || '',
          platform: course.platform || '',
          link: course.link || course.url || '',
          price: course.price || '',
          priceUnit: course.priceUnit || 'NGN',
        },
      },
    });
  };

  const location = useLocation();

  const resolveTab = (search) => {
    const tab = new URLSearchParams(search).get('tab');
    if (tab === 'recommendations') return 'courses';
    if (tab === 'recommended') return 'overview';
    if (tab === 'goals') return 'profile';
    return ['overview', 'edubuddy', 'profile', 'courses', 'messages'].includes(tab) ? tab : 'overview';
  };

  const [activeTab, setActiveTab] = useState(() => resolveTab(window.location.search));

  // Sync active tab whenever the URL query string changes (e.g. navigate() from modal)
  useEffect(() => {
    setActiveTab(resolveTab(location.search));
  }, [location.search]);
  const [claimNotice, setClaimNotice] = useState(() =>
    new URLSearchParams(window.location.search).get('claimed') === '1'
      ? 'Moji conversation is saved. Finish the chat below to unlock your full list of course matches.'
      : null
  );

  // Core data
  const [userDetails, setUserDetails] = useState(null);
  const [dashboardCourses, setDashboardCourses] = useState([]);
  const [courseGroups, setCourseGroups] = useState(null);
  const [recommendationsStale, setRecommendationsStale] = useState(false);
  const [refreshingRecs, setRefreshingRecs] = useState(false);
  const [requests, setRequests] = useState([]);
  const [learnerProfile, setLearnerProfile] = useState({});
  const [socialProfiles, setSocialProfiles] = useState({});
  const [academicProfiles, setAcademicProfiles] = useState({});
  const [wishlist, setWishlist] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  // Profile modal (initial completion)
  const [showProfileModal, setShowProfileModal] = useState(false);

  // Certificate upload modal
  const [showCertModal, setShowCertModal] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  // Course detail modal
  const [selectedCatCourse, setSelectedCatCourse] = useState(null);

  // Courses sub-tab state
  const [coursesSubTab, setCoursesSubTab] = useState('enrolled');
  const [enrollingId, setEnrollingId] = useState(null);
  const [wishlistLoading, setWishlistLoading] = useState({});

  // Profile edit states (locked by default)
  const [editingProfile, setEditingProfile] = useState(false);
  const [editingSocial, setEditingSocial] = useState(false);
  const [editingGoals, setEditingGoals] = useState(false);
  const [editingAvail, setEditingAvail] = useState(false);
  const [profileSaving, setProfileSaving] = useState(false);
  const [profileForm, setProfileForm] = useState({
    fullName: '', phoneNumber: '', country: '', gender: '', bio: '', location: '',
  });
  const [profilePicFile, setProfilePicFile] = useState(null);
  const [profilePicPreview, setProfilePicPreview] = useState(null);
  const avatarInputRef = useRef();

  // Goals & interests state
  const [goalsSaving, setGoalsSaving] = useState(false);
  const [goalsForm, setGoalsForm] = useState({
    primary_goal: '',
    interests: [],
    target_industries: [],
    target_roles: '',
  });

  // Availability state
  const [availSaving, setAvailSaving] = useState(false);
  const [availForm, setAvailForm] = useState({
    weekly_hours: '',
    motivation_level: '',
    device: '',
    preferred_learning_style: '',
    budget: '',
  });

  // Social & academic state
  const [socialSaving, setSocialSaving] = useState(false);
  const [socialForm, setSocialForm] = useState({
    linkedin: '', twitter: '', github: '', portfolio: '',
  });
  const [academicForm, setAcademicForm] = useState({
    institution: '', fieldOfStudy: '', highestDegree: '', certifications: '',
  });

  // Messaging state
  const [msgThreads, setMsgThreads] = useState([]);
  const [msgLoading, setMsgLoading] = useState(false);
  const [selectedThread, setSelectedThread] = useState(null);
  const [replyContent, setReplyContent] = useState('');
  const [replying, setReplying] = useState(false);
  const msgBottomRef = useRef();

  // Interest search filter
  const [interestSearch, setInterestSearch] = useState('');

  // Progressive reveal counts for pill-option questions (show 5 at a time)
  const PILL_PAGE_SIZE = 5;
  const [visibleGoalsCount, setVisibleGoalsCount] = useState(PILL_PAGE_SIZE);
  const [visibleInterestsCount, setVisibleInterestsCount] = useState(PILL_PAGE_SIZE);
  const [visibleIndustriesCount, setVisibleIndustriesCount] = useState(PILL_PAGE_SIZE);

  // Reset the interests reveal count whenever the filter changes
  useEffect(() => {
    setVisibleInterestsCount(PILL_PAGE_SIZE);
  }, [interestSearch]);

  // Rating / review modal state
  const [showReviewModal, setShowReviewModal] = useState(false);
  const [reviewCourse, setReviewCourse] = useState(null);
  const [reviewScore, setReviewScore] = useState(0);
  const [reviewText, setReviewText] = useState('');
  const [reviewSubmitting, setReviewSubmitting] = useState(false);

  // Discussion modal state
  const [showDiscModal, setShowDiscModal] = useState(false);
  const [discCourse, setDiscCourse] = useState(null);
  const [discPosts, setDiscPosts] = useState([]);
  const [discLoading, setDiscLoading] = useState(false);
  const [discMessage, setDiscMessage] = useState('');
  const [discPosting, setDiscPosting] = useState(false);

  // Learning Identity state
  const [learningIdentity, setLearningIdentity] = useState(null);
  const [showIdentityModal, setShowIdentityModal] = useState(false);

  // ─── Fetch dashboard data ─────────────────────────────────────────────────
  useEffect(() => {
    const fetchData = async () => {
      // Only the first load blocks the page; later refreshes happen quietly so
      // they don't tear down the chat panel or the tab the learner is reading.
      const isFirstLoad = refreshKey === 0;
      if (isFirstLoad) setLoading(true);
      setError(null);
      try {
        // A guest conversation can still be waiting to be attached — the claim
        // needs a verified account with a learner profile, so an attempt made at
        // signup time may have been rejected. This is the retry point.
        if (isFirstLoad && hasGuestChat()) {
          const claimed = await claimGuestChat();
          if (claimed) {
            const carried = claimed.carried_recommendations;
            setClaimNotice(
              `We saved your earlier Moji conversation${carried ? ` and ${carried} course matches` : ''}. Finish the chat below to unlock your full list.`
            );
            setActiveTab('edubuddy');
          }
        }

        const res = await axiosInstance.get('/dashboard');
        const d = res.data;

        setUserDetails(d.userDetails);
        setDashboardCourses(d.dashboardCourses || []);
        setCourseGroups(d.courseGroups || null);
        setRecommendationsStale(!!d.recommendationsStale);
        setRequests(d.requests || []);
        setLearnerProfile(d.learnerProfile || {});
        setSocialProfiles(d.socialProfiles || {});
        setAcademicProfiles(d.academicProfiles || {});
        setWishlist(d.wishlist || []);

        if (d.learningIdentity) {
          setLearningIdentity(d.learningIdentity);
        } else {
          axiosInstance.get('/recommendations/learning-identity')
            .then(identityRes => {
              if (identityRes.data?.learningIdentity) setLearningIdentity(identityRes.data.learningIdentity);
            })
            .catch(() => {});
        }

        // Sync local form states
        setProfileForm({
          fullName: d.userDetails?.fullName || '',
          phoneNumber: d.userDetails?.phoneNumber || '',
          country: d.userDetails?.country || '',
          gender: d.userDetails?.gender || '',
          bio: d.userDetails?.bio || '',
          location: d.userDetails?.location || '',
        });
        setGoalsForm({
          primary_goal: d.learnerProfile?.primary_goal || '',
          interests: d.learnerProfile?.interests || [],
          target_industries: d.learnerProfile?.target_industries || [],
          target_roles: (d.learnerProfile?.target_roles || []).join(', '),
        });
        setAvailForm({
          weekly_hours: d.learnerProfile?.weekly_hours || '',
          motivation_level: d.learnerProfile?.motivation_level || '',
          device: d.learnerProfile?.device || '',
          preferred_learning_style: d.learnerProfile?.preferred_learning_style || '',
          budget: d.learnerProfile?.budget || '',
        });
        setSocialForm({
          linkedin: d.socialProfiles?.linkedin || '',
          twitter: d.socialProfiles?.twitter || '',
          github: d.socialProfiles?.github || '',
          portfolio: d.socialProfiles?.portfolio || '',
        });
        setAcademicForm({
          institution: d.academicProfiles?.institution || '',
          fieldOfStudy: d.academicProfiles?.fieldOfStudy || '',
          highestDegree: d.academicProfiles?.highestDegree || '',
          certifications: (d.academicProfiles?.certifications || []).join(', '),
        });

        // Show completion modal if core fields missing
        if (!d.userDetails?.fullName || !d.userDetails?.phoneNumber) {
          setShowProfileModal(true);
        }
      } catch (err) {
        const msg = err.response?.data?.message || 'Failed to load dashboard. Please try again.';
        // A failed background refresh keeps the page the learner is on.
        if (isFirstLoad) setError(msg);
        else toast.error(msg);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [refreshKey]);

  // Auto-synchronize data collected by Moji directly into Availability & Learning Pace form
  useEffect(() => {
    if (learnerProfile) {
      setAvailForm(p => ({
        weekly_hours: learnerProfile.weekly_hours || p.weekly_hours || '',
        motivation_level: learnerProfile.motivation_level || p.motivation_level || '',
        device: learnerProfile.device || p.device || '',
        preferred_learning_style: learnerProfile.preferred_learning_style || p.preferred_learning_style || '',
        budget: learnerProfile.budget || p.budget || '',
      }));
    }
  }, [learnerProfile]);

  const isInitialMount = useRef(true);
  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    if (activeTab === 'overview' || activeTab === 'profile' || activeTab === 'goals') {
      setRefreshKey(k => k + 1);
    }
  }, [activeTab]);


  // ─── Course row updates ───────────────────────────────────────────────────
  // A course row is rendered from both the flat list and courseGroups, so
  // optimistic updates have to land in both to avoid a stale-looking card.
  const patchCourse = (id, patch) => {
    const apply = list => (list || []).map(c => (c._id === id ? { ...c, ...patch } : c));
    setDashboardCourses(prev => apply(prev));
    setCourseGroups(prev =>
      prev
        ? Object.fromEntries(
            Object.entries(prev).map(([key, value]) => [key, Array.isArray(value) ? apply(value) : value])
          )
        : prev
    );
  };

  // ─── Regenerate recommendations ───────────────────────────────────────────
  const handleRefreshRecommendations = async () => {
    setRefreshingRecs(true);
    try {
      // Regeneration is an embedding call plus an LLM rerank, so this can take
      // several seconds; `regenerated: false` means the cache was served.
      const res = await recService.getRecommendations();
      toast.success(
        res?.regenerated
          ? 'Recommendations rebuilt from your latest preferences.'
          : 'Your recommendations are already up to date.'
      );
      setRefreshKey(k => k + 1);
    } catch (err) {
      const msg = err.message || 'Could not refresh recommendations.';
      toast.error(msg);
      // "Profile is incomplete" — the fix is more intake, so send them there.
      if (/incomplete/i.test(msg)) setActiveTab('edubuddy');
    } finally {
      setRefreshingRecs(false);
    }
  };

  // ─── Logout ───────────────────────────────────────────────────────────────
  const handleLogout = () => {
    ['motivar-token', 'motivar-refresh-token', 'motivar-user-role', 'motivar-user-fname'].forEach(k =>
      localStorage.removeItem(k)
    );
    window.location.href = '/';
  };

  // ─── Profile update ───────────────────────────────────────────────────────
  const handleProfileSave = async () => {
    setProfileSaving(true);
    try {
      const formData = new FormData();
      Object.entries(profileForm).forEach(([k, v]) => { if (v) formData.append(k, v); });
      if (profilePicFile) formData.append('profilePicture', profilePicFile);

      await axiosInstance.patch('/user/profile/update', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      toast.success('Profile updated successfully.');
      setEditingProfile(false);
      setProfilePicFile(null);
      setProfilePicPreview(null);
      setRefreshKey(k => k + 1);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update profile.');
    } finally {
      setProfileSaving(false);
    }
  };

  // ─── Goals & interests save ───────────────────────────────────────────────
  const handleGoalsSave = async () => {
    setGoalsSaving(true);
    try {
      await axiosInstance.patch(
        '/dashboard/learner-profile',
        {
          primary_goal: goalsForm.primary_goal,
          interests: goalsForm.interests,
          target_industries: goalsForm.target_industries,
          target_roles: goalsForm.target_roles
            ? goalsForm.target_roles.split(',').map(s => s.trim()).filter(Boolean)
            : [],
        }
      );
      toast.success('Goals & interests saved.');
      setEditingGoals(false);
      setLearnerProfile(p => ({
        ...p,
        primary_goal: goalsForm.primary_goal,
        interests: goalsForm.interests,
        target_industries: goalsForm.target_industries,
      }));
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to save goals.');
    } finally {
      setGoalsSaving(false);
    }
  };

  // ─── Availability save ────────────────────────────────────────────────────
  const handleAvailSave = async () => {
    setAvailSaving(true);
    try {
      await axiosInstance.patch(
        '/dashboard/learner-profile',
        {
          weekly_hours: availForm.weekly_hours ? Number(availForm.weekly_hours) : undefined,
          motivation_level: availForm.motivation_level || undefined,
          device: availForm.device || undefined,
          preferred_learning_style: availForm.preferred_learning_style || undefined,
          budget: availForm.budget || undefined,
        }
      );
      toast.success('Availability preferences saved.');
      setEditingAvail(false);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to save availability.');
    } finally {
      setAvailSaving(false);
    }
  };

  // ─── Social & academic save ───────────────────────────────────────────────
  const handleSocialSave = async () => {
    setSocialSaving(true);
    try {
      await axiosInstance.patch(
        '/dashboard/learner-profile',
        {
          socialProfiles: socialForm,
          academicProfiles: {
            ...academicForm,
            certifications: academicForm.certifications
              ? academicForm.certifications.split(',').map(s => s.trim()).filter(Boolean)
              : [],
          },
        }
      );
      toast.success('Social & academic profiles saved.');
      setSocialProfiles(socialForm);
      setEditingSocial(false);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to save profiles.');
    } finally {
      setSocialSaving(false);
    }
  };

  // ─── Certificate upload ───────────────────────────────────────────────────
  const handleUploadCertificate = async () => {
    if (!selectedFile) { toast.error('Please select a file.'); return; }
    setIsUploading(true);
    try {
      const formData = new FormData();
      formData.append('certificate', selectedFile);
      await axiosInstance.put(
        `/dashboard/${selectedCourse._id}/upload-completion-certificate`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      patchCourse(selectedCourse._id, { status: 'completed', completionCertificate: 'uploaded' });
      toast.success('Certificate uploaded successfully.');
      setShowCertModal(false);
      setSelectedFile(null);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to upload certificate.');
    } finally {
      setIsUploading(false);
    }
  };

  // ─── Enroll in free course ────────────────────────────────────────────────
  const handleEnroll = async (course) => {
    setEnrollingId(course._id);
    try {
      await axiosInstance.post(`/dashboard/enroll/${course._id}`, {});
      toast.success(`Enrolled in "${course.title}"!`);
      setRefreshKey(k => k + 1);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not enroll. Try again.');
    } finally {
      setEnrollingId(null);
    }
  };

  // ─── Wishlist toggle ──────────────────────────────────────────────────────
  const handleWishlistToggle = async (course) => {
    const inWishlist = wishlist.some(w => w.courseId === course._id || w.title === course.title);
    setWishlistLoading(p => ({ ...p, [course._id]: true }));
    try {
      if (inWishlist) {
        const item = wishlist.find(w => w.courseId === course._id || w.title === course.title);
        if (item) {
          await axiosInstance.delete(`/dashboard/wishlist/${item._id}`);
          setWishlist(prev => prev.filter(w => w._id !== item._id));
          toast.success('Removed from wishlist.');
        }
      } else {
        const res = await axiosInstance.post(
          '/dashboard/wishlist',
          {
            courseId: course._id,
            title: course.title,
            url: course.url,
            platform: course.platform,
            status: course.status,
            price: course.price,
            priceUnit: course.priceUnit,
          }
        );
        setWishlist(res.data.wishlist || []);
        toast.success('Added to wishlist.');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not update wishlist.');
    } finally {
      setWishlistLoading(p => ({ ...p, [course._id]: false }));
    }
  };

  // ─── Avatar change ────────────────────────────────────────────────────────
  const handleAvatarChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) { toast.error('Only image files are allowed.'); return; }
    if (file.size > 5 * 1024 * 1024) { toast.error('Image must be under 5 MB.'); return; }
    setProfilePicFile(file);
    setProfilePicPreview((prev) => {
      if (prev) URL.revokeObjectURL(prev);
      return URL.createObjectURL(file);
    });
  };

  // ─── Mark course complete ─────────────────────────────────────────────────
  const handleMarkComplete = async (course) => {
    try {
      await axiosInstance.patch(`/dashboard/courses/${course._id}/complete`, {});
      patchCourse(course._id, { status: 'completed' });
      toast.success(`"${course.title}" marked as completed!`);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not mark course as complete.');
    }
  };

  // ─── Delete course from dashboard ─────────────────────────────────────────
  const handleDeleteCourse = async (course) => {
    try {
      await axiosInstance.delete(`/dashboard/courses/${course._id}`);
      setDashboardCourses(prev => prev.filter(c => c._id !== course._id));
      if (courseGroups) {
        setCourseGroups(prev => ({
          ...prev,
          recommended: (prev.recommended || []).filter(c => c._id !== course._id),
          enrolled: (prev.enrolled || []).filter(c => c._id !== course._id),
          sponsored: (prev.sponsored || []).filter(c => c._id !== course._id),
          manual: (prev.manual || []).filter(c => c._id !== course._id),
        }));
      }
      toast.success('Course removed.');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not remove course.');
    }
  };

  // ─── Submit review ────────────────────────────────────────────────────────
  const handleSubmitReview = async () => {
    if (!reviewScore) { toast.error('Please select a star rating.'); return; }
    setReviewSubmitting(true);
    try {
      await axiosInstance.post(
        `/dashboard/courses/${reviewCourse._id}/review`,
        { score: reviewScore, review: reviewText }
      );
      toast.success('Review submitted! Thank you.');
      patchCourse(reviewCourse._id, { rating: { score: reviewScore, review: reviewText } });
      setShowReviewModal(false);
      setReviewScore(0);
      setReviewText('');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not submit review.');
    } finally {
      setReviewSubmitting(false);
    }
  };

  // ─── Load discussion ──────────────────────────────────────────────────────
  const loadDiscussion = async (course) => {
    setDiscCourse(course);
    setShowDiscModal(true);
    setDiscPosts([]);
    setDiscLoading(true);
    try {
      const id = course.courseId || course._id;
      const res = await axiosInstance.get(`/dashboard/courses/${id}/discussion`);
      setDiscPosts(res.data.data.posts || []);
    } catch {
      toast.error('Could not load discussion.');
    } finally {
      setDiscLoading(false);
    }
  };

  // ─── Post to discussion ───────────────────────────────────────────────────
  const handlePostDiscussion = async () => {
    if (!discMessage.trim()) return;
    setDiscPosting(true);
    try {
      const id = discCourse.courseId || discCourse._id;
      const res = await axiosInstance.post(
        `/dashboard/courses/${id}/discussion`,
        { message: discMessage.trim() }
      );
      setDiscPosts(prev => [res.data.data.post, ...prev]);
      setDiscMessage('');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not post message.');
    } finally {
      setDiscPosting(false);
    }
  };

  // ─── Messaging ────────────────────────────────────────────────────────────
  const fetchMessages = async () => {
    setMsgLoading(true);
    try {
      const res = await axiosInstance.get('/dashboard/messages');
      setMsgThreads(res.data.threads || []);
    } catch {
      toast.error('Failed to load messages.');
    } finally {
      setMsgLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab === 'messages') fetchMessages();
  }, [activeTab]);

  const handleReply = async () => {
    if (!replyContent.trim() || !selectedThread) return;
    setReplying(true);
    try {
      const res = await axiosInstance.post(
        `/dashboard/messages/${selectedThread.threadId}/reply`,
        { content: replyContent.trim() }
      );
      const newMsg = res.data.msg;
      setSelectedThread(prev => ({ ...prev, messages: [...prev.messages, newMsg] }));
      setMsgThreads(prev => prev.map(t =>
        t.threadId === selectedThread.threadId
          ? { ...t, messages: [...t.messages, newMsg], lastMessage: newMsg }
          : t
      ));
      setReplyContent('');
      setTimeout(() => msgBottomRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Could not send reply.');
    } finally {
      setReplying(false);
    }
  };

  // ─── Computed ─────────────────────────────────────────────────────────────
  const pendingCount = requests.filter(r => !r.paid).length;
  const paidCount = requests.filter(r => r.paid).length;

  // Group courses by where they came from. `addedBy: 'enrolled'` is new — free
  // enrollments used to be written as 'manual', and rows created before that
  // change still are, so the two are shown together.
  const groups = courseGroups || {};
  const enrolledList = courseGroups
    ? [...(groups.enrolled || []), ...(groups.manual || [])]
    : dashboardCourses;
  const recommendedList = groups.recommended || [];
  const sponsoredList = groups.sponsored || [];

  const enrolledCount = enrolledList.length;
  const completedCount = enrolledList.filter(c => c.status === 'completed').length;

  const getInitials = (name) => {
    if (!name || typeof name !== 'string') return '?';
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  };

  const profilePicSrc = profilePicPreview
    || (userDetails?.profilePicture?.data
      ? `data:${userDetails.profilePicture.contentType};base64,${Buffer.from(userDetails.profilePicture.data.data).toString('base64')}`
      : null);

  // Profile Completeness Checklist items
  const profileChecklist = [
    { label: 'Primary Goal', weight: 25, isDone: !!learnerProfile?.primary_goal, targetTab: 'goals' },
    { label: 'Interests', weight: 25, isDone: (learnerProfile?.interests?.length || 0) > 0, targetTab: 'goals' },
    { label: 'Bio & Overview', weight: 20, isDone: !!userDetails?.bio, targetTab: 'profile' },
    { label: 'Location / Country', weight: 15, isDone: !!userDetails?.country, targetTab: 'profile' },
    { label: 'Academic / Social Link', weight: 15, isDone: !!(academicProfiles?.institution || socialProfiles?.linkedin), targetTab: 'profile' },
  ];
  const completenessPercent = profileChecklist.filter(i => i.isDone).reduce((sum, i) => sum + i.weight, 0);
  const incompleteChecklist = profileChecklist.filter(i => !i.isDone);

  // ─── Loading / error states ───────────────────────────────────────────────
  if (loading) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
        <Spinner animation="border" style={{ color: brand.primary, width: '3rem', height: '3rem' }} />
        <p className="mt-3" style={{ color: brand.textSub }}>Loading your dashboard...</p>
      </div>
    );
  }

  if (error) {
    return (
      <Container className="pt-5 text-center">
        <Alert variant="danger" className="d-inline-flex align-items-center gap-2">
          <FiAlertCircle /> {error}
        </Alert>
      </Container>
    );
  }

  // ─── Tab content renderers ────────────────────────────────────────────────

  // ── Overview Tab ────────────────────────────────────────────────────────
  const OverviewTab = () => (
    <>
      {/* Profile Completeness Interactive Checklist (Shows if < 100%) */}
      {completenessPercent < 100 && incompleteChecklist.length > 0 && (
        <SectionCard className="mb-3" style={{ borderRadius: '12px', border: '1px solid rgba(0, 170, 135, 0.18)', background: '#ffffff', boxShadow: '0 2px 8px rgba(0, 170, 135, 0.04)' }}>
          <Card.Body style={{ padding: '0.75rem 0.9rem' }}>
            <CompletenessWrap>
              <div className="completeness-head">
                <div className="completeness-label">
                  <div style={{ width: 26, height: 26, borderRadius: '50%', background: 'rgba(0, 170, 135, 0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <FiUser style={{ color: 'var(--primary-color)', fontSize: '0.85rem' }} />
                  </div>
                  <span style={{ fontWeight: 700, fontSize: '0.85rem', color: brand.text, whiteSpace: 'nowrap' }}>Profile {completenessPercent}%</span>
                </div>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="completeness-hover-tooltip">Click an item to complete your profile & reach 100%!</Tooltip>}
                >
                  <div className="completeness-bar">
                    <div
                      style={{
                        width: `${completenessPercent}%`,
                        background: 'linear-gradient(90deg, #00AA87 0%, #00C896 100%)',
                        height: '100%',
                        borderRadius: '8px',
                        transition: 'width 0.6s ease',
                      }}
                    />
                  </div>
                </OverlayTrigger>
              </div>

              <div className="completeness-chips">
                {incompleteChecklist.map(item => (
                  <button
                    key={item.label}
                    type="button"
                    className="completeness-chip"
                    onClick={() => setActiveTab(item.targetTab)}
                    title={`Add ${item.label} to reach ${completenessPercent + item.weight}%`}
                    style={{
                      background: 'rgba(0, 170, 135, 0.08)',
                      color: '#00886C',
                      border: '1px solid rgba(0, 170, 135, 0.22)',
                      borderRadius: '50px',
                      padding: '0.28rem 0.4rem',
                      fontSize: '0.68rem',
                      fontWeight: 600,
                      cursor: 'pointer',
                      transition: 'all 0.15s ease',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '0.25rem',
                    }}
                  >
                    + {item.label} <span style={{ background: '#ffffff', color: '#00886C', padding: '0.02rem 0.28rem', borderRadius: '10px', fontSize: '0.62rem', fontWeight: 700, flexShrink: 0 }}>+{item.weight}%</span>
                  </button>
                ))}
              </div>
            </CompletenessWrap>
          </Card.Body>
        </SectionCard>
      )}

      {/* Summary cards */}
      <Row className="g-3 mb-4">
        {[
          { icon: <FiClock />, value: pendingCount, label: 'Pending Requests', ic: brand.warning, vc: brand.warning },
          { icon: <FiCheckCircle />, value: paidCount, label: 'Paid Requests', ic: brand.success, vc: brand.success },
          { icon: <FiBookOpen />, value: enrolledCount, label: 'Enrolled Courses', ic: brand.primary, vc: brand.primary },
          { icon: <FiCheckCircle />, value: completedCount, label: 'Completed', ic: brand.success, vc: brand.primaryDark },
        ].map(({ icon, value, label, ic, vc }) => (
          <Col md={3} sm={6} key={label}>
            <SummaryCard iconColor={ic} valueColor={vc}>
              <div className="summary-icon">{icon}</div>
              <p className="summary-value">{value}</p>
              <h5>{label}</h5>
            </SummaryCard>
          </Col>
        ))}
      </Row>


      {/* Preference-driven recommendations lead the page */}
      <SectionCard className="mb-4">
        <Card.Header>
          <FiStar /> Recommended for you
          <PrimaryBtn
            size="sm"
            variant="outline-primary"
            className="ms-auto"
            onClick={handleRefreshRecommendations}
            disabled={refreshingRecs}
            style={{ padding: '0.3rem 0.9rem', fontSize: '0.78rem' }}
          >
            {refreshingRecs
              ? <><Spinner animation="border" size="sm" className="me-1" /> Refreshing…</>
              : <><FiRefreshCw size="0.85em" /> Refresh</>}
          </PrimaryBtn>
        </Card.Header>

        {/* The backend also reports stale when nothing has ever been generated,
            so only flag it where there is actually something to refresh. */}
        {recommendationsStale && recommendedList.length > 0 && (
          <div style={{ background: '#fff8ec', borderBottom: '1px solid #ffe0b2', padding: '0.6rem 1.25rem', fontSize: 13, color: '#7a5c00' }}>
            Your preferences have changed since these were generated — refresh to get a fresh match.
          </div>
        )}

        <Card.Body className="p-3">
          {recommendedList.length === 0 ? (
            <div className="text-center text-muted py-4">
              <FiTarget size={30} style={{ marginBottom: 10, opacity: 0.4 }} />
              <p style={{ fontSize: 14, marginBottom: 12 }}>
                No recommendations yet — tell Moji about your goals and we'll match courses to them.
              </p>
              <PrimaryBtn size="sm" onClick={() => setActiveTab('edubuddy')}>
                <FiMessageCircle size="0.9em" /> Talk to Moji
              </PrimaryBtn>
            </div>
          ) : (
            <Row className="g-3">
              {recommendedList.map(course => {
                const url = course.link || course.url || '';
                const href = url.startsWith('http') ? url : `https://${url}`;
                return (
                  <Col md={4} sm={6} key={course._id || course.title}>
                    <CourseCard>
                      <Card.Body className="d-flex flex-column">
                        <div className="card-title">{course.title}</div>
                        
                        {/* Course Badges: Platform, Level, Price */}
                        <div className="d-flex flex-wrap gap-1 mb-2">
                          {course.platform && (
                            <StyledBadge pill bg="" style={{ backgroundColor: 'rgba(0, 170, 135, 0.1)', color: brand.primary, fontWeight: 600 }}>
                              {course.platform}
                            </StyledBadge>
                          )}
                          {course.level && (
                            <StyledBadge pill bg="" style={{ backgroundColor: '#f1f5f9', color: brand.textSub, fontWeight: 600 }}>
                              <FiBarChart2 size="0.85em" /> {course.level}
                            </StyledBadge>
                          )}
                          {(course.status === 'Free' || course.price === 0 || !course.price) ? (
                            <StyledBadge pill bg="" style={{ backgroundColor: 'rgba(40, 167, 69, 0.12)', color: '#28a745', fontWeight: 600 }}>
                              Free
                            </StyledBadge>
                          ) : (
                            <StyledBadge pill bg="" style={{ backgroundColor: 'rgba(255, 122, 89, 0.12)', color: 'var(--secondary-color)', fontWeight: 600 }}>
                              {course.priceUnit || ''} {course.price}
                            </StyledBadge>
                          )}
                        </div>

                        <p className="card-text mb-3" style={{ flexGrow: 1 }}>
                          {course.description?.length > 90
                            ? `${course.description.slice(0, 90)}...`
                            : course.description || ''}
                        </p>
                        <div className="d-flex flex-column gap-2 mt-auto">
                          <PrimaryBtn
                            size="sm"
                            onClick={() => handleRequestSponsorship(course)}
                            style={{ width: '100%', fontSize: '0.78rem', justifyContent: 'center' }}
                          >
                            <FiGift size="0.85em" /> Request Sponsorship
                          </PrimaryBtn>
                          <div className="d-flex gap-2">
                            {url && (
                              <a href={href} target="_blank" rel="noopener noreferrer" style={{ flex: 1 }}>
                                <PrimaryBtn size="sm" variant="outline-primary" style={{ width: '100%', fontSize: '0.78rem', justifyContent: 'center' }}>
                                  <FiExternalLink size="0.85em" /> View
                                </PrimaryBtn>
                              </a>
                            )}
                            <PrimaryBtn
                              size="sm"
                              variant="outline-danger"
                              title="Delete recommendation"
                              onClick={() => handleDeleteCourse(course)}
                              style={{ flex: '0 0 auto', padding: '0.4rem 0.6rem', justifyContent: 'center' }}
                            >
                              <FiTrash2 size="0.85em" />
                            </PrimaryBtn>
                          </div>
                        </div>
                      </Card.Body>
                    </CourseCard>
                  </Col>
                );
              })}
            </Row>
          )}
        </Card.Body>
      </SectionCard>

      {/* Sponsored courses */}
      {sponsoredList.length > 0 && (
        <SectionCard className="mb-4">
          <Card.Header><FiGift /> Sponsored for you ({sponsoredList.length})</Card.Header>
          <ListGroup variant="flush">
            {sponsoredList.map(course => {
              const url = course.link || course.url || '';
              const href = url.startsWith('http') ? url : `https://${url}`;
              return (
                <StyledListItem key={course._id || course.title} iconColor={brand.success}>
                  <div className="icon-wrap"><FiGift /></div>
                  <div className="content" style={{ flex: 1 }}>
                    <h6>{course.title}</h6>
                    <StyledBadge className={course.status === 'completed' ? 'bg-completed' : 'bg-uncompleted'}>
                      {course.status === 'completed' ? 'Completed' : 'In Progress'}
                    </StyledBadge>
                  </div>
                  {url && (
                    <a href={href} target="_blank" rel="noopener noreferrer">
                      <PrimaryBtn size="sm" variant="outline-primary"><FiExternalLink size="0.85em" /> Open</PrimaryBtn>
                    </a>
                  )}
                </StyledListItem>
              );
            })}
          </ListGroup>
        </SectionCard>
      )}



      {/* Requests & Enrolled Courses */}
      <Row className="g-4">
        <Col lg={6}>
          <SectionCard>
            <Card.Header><FiList /> Your Course Requests</Card.Header>
            <ListGroup variant="flush">
              {requests.length > 0 ? requests.map(req => {
                const isPaidAndEnrolled = !!req.paid || req.status === 'funded' || req.status === 'paid_and_enrolled';
                const isSearchingForSponsors = !isPaidAndEnrolled;
                const steps = [
                  { title: 'Submitted', done: true },
                  { title: 'Reviewing', done: req.status === 'in_review' || req.status === 'sponsor_matched' || req.status === 'funded' || true },
                  { title: 'Matched', done: req.status === 'sponsor_matched' || req.status === 'funded' || !!req.paid },
                  { title: 'Funded', done: req.status === 'funded' || !!req.paid },
                ];
                return (
                  <StyledListItem key={req._id} iconColor={req.paid ? brand.success : brand.warning}>
                    <div className="icon-wrap">{req.paid ? <FiCheckCircle /> : <FiClock />}</div>
                    <div className="content" style={{ width: '100%' }}>
                      <div className="d-flex justify-content-between align-items-start mb-1">
                        <h6>{req.course?.courseTitle || 'Course Title Missing'}</h6>
                        <StyledBadge className={req.paid ? 'bg-paid' : 'bg-pending'}>
                          {req.paid ? 'Paid & Enrolled' : 'Searching for Sponsors'}
                        </StyledBadge>
                      </div>
                      <p className="text-muted mb-2">
                        {req.course?.platform || 'N/A'} &middot; {req.course?.price || 'N/A'} {req.course?.priceUnit || ''}
                      </p>

                      {/* Application Status Timeline Stepper - only visible while searching for sponsors */}
                      {isSearchingForSponsors && (
                        <div className="mt-3 pt-2 border-top">
                          <div className="d-flex align-items-center justify-content-between position-relative">
                            {steps.map((step, idx) => {
                              const isDone = step.done;
                              const isLast = idx === steps.length - 1;
                              return (
                                <React.Fragment key={step.title}>
                                  <div className="d-flex flex-column align-items-center" style={{ zIndex: 2, position: 'relative' }}>
                                    <div
                                      style={{
                                        width: 22,
                                        height: 22,
                                        borderRadius: '50%',
                                        backgroundColor: isDone ? 'var(--primary-color)' : '#e2e8f0',
                                        color: isDone ? '#fff' : '#94a3b8',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontSize: '0.65rem',
                                        fontWeight: 700,
                                        transition: 'all 0.3s ease',
                                      }}
                                    >
                                      {isDone ? <FiCheckCircle size="0.85em" /> : idx + 1}
                                    </div>
                                    <span
                                      style={{
                                        fontSize: '0.68rem',
                                        fontWeight: isDone ? 600 : 500,
                                        color: isDone ? 'var(--text-primary)' : 'var(--text-muted)',
                                        marginTop: 4,
                                        textAlign: 'center',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {step.title}
                                    </span>
                                  </div>
                                  {!isLast && (
                                    <div
                                      style={{
                                        flexGrow: 1,
                                        height: 2,
                                        backgroundColor: steps[idx + 1].done ? 'var(--primary-color)' : '#e2e8f0',
                                        marginTop: -14,
                                        marginLeft: 4,
                                        marginRight: 4,
                                        transition: 'background-color 0.3s ease',
                                      }}
                                    />
                                  )}
                                </React.Fragment>
                              );
                            })}
                          </div>
                        </div>
                      )}

                      {req.motivation && (
                        <p className="text-muted mt-2 small font-italic">"{req.motivation}"</p>
                      )}
                    </div>
                  </StyledListItem>
                );
              }) : (
                <ListGroup.Item className="text-center text-muted p-4">No requests yet.</ListGroup.Item>
              )}
            </ListGroup>
          </SectionCard>
        </Col>

        <Col lg={6}>
          <SectionCard>
            <Card.Header><FiBookOpen /> Your Enrolled Courses</Card.Header>
            <ListGroup variant="flush">
              {enrolledList.length > 0 ? enrolledList.map(course => {
                const courseUrl = course.link?.startsWith('http') ? course.link : `https://${course.link}`;
                const done = course.status === 'completed';
                return (
                  <StyledListItem key={course._id} iconColor={done ? brand.success : brand.warning}
                    style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <a
                      href={!done ? courseUrl : undefined}
                      target={!done ? '_blank' : undefined}
                      rel="noopener noreferrer"
                      style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flex: 1, textDecoration: 'none', color: 'inherit', cursor: !done ? 'pointer' : 'default' }}
                      onClick={done ? e => e.preventDefault() : undefined}
                    >
                      <div className="icon-wrap"><FiBookOpen /></div>
                      <div className="content">
                        <h6>{course.title}</h6>
                        <p className="text-muted small">
                          {course.description?.length > 60
                            ? `${course.description.slice(0, 60)}...`
                            : course.description}
                        </p>
                        <StyledBadge className={done ? 'bg-completed' : 'bg-uncompleted'}>
                          {done ? 'Completed' : 'In Progress'}
                        </StyledBadge>
                      </div>
                    </a>
                    <div style={{ flexShrink: 0, marginLeft: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                      {done ? (
                        <>
                          {course.completionCertificate && (
                            <PrimaryBtn
                              size="sm"
                              variant="outline-primary"
                              onClick={async () => {
                                try {
                                  const res = await axiosInstance.get(`/dashboard/${course._id}/view-certificate`, { responseType: 'blob' });
                                  window.open(URL.createObjectURL(res.data), '_blank', 'noopener,noreferrer');
                                } catch { toast.error('Could not retrieve certificate.'); }
                              }}
                            >
                              View Cert
                            </PrimaryBtn>
                          )}
                          <PrimaryBtn
                            size="sm"
                            variant="outline-primary"
                            onClick={() => { setReviewCourse(course); setReviewScore(course.rating?.score || 0); setReviewText(course.rating?.review || ''); setShowReviewModal(true); }}
                          >
                            <FiStar size="0.85em" /> {course.rating ? 'Edit Review' : 'Rate'}
                          </PrimaryBtn>
                        </>
                      ) : (
                        <>
                          <PrimaryBtn
                            size="sm"
                            variant="outline-primary"
                            onClick={() => { setSelectedCourse(course); setShowCertModal(true); }}
                          >
                            <FiUpload size="0.85em" /> Upload Cert
                          </PrimaryBtn>
                        </>
                      )}
                      <PrimaryBtn
                        size="sm"
                        variant="outline-primary"
                        onClick={() => loadDiscussion(course)}
                      >
                        <FiMessageSquare size="0.85em" /> Forum
                      </PrimaryBtn>
                    </div>
                  </StyledListItem>
                );
              }) : (
                <ListGroup.Item className="text-center text-muted p-4">
                  <p className="mb-3">No enrolled courses yet.</p>
                  <Link to="/explore" className="text-decoration-none">
                    <PrimaryBtn size="sm" variant="primary" style={{ padding: '0.5rem 1.25rem' }}>
                      <FiBookOpen className="me-2" /> Browse Catalogue
                    </PrimaryBtn>
                  </Link>
                </ListGroup.Item>
              )}
            </ListGroup>
          </SectionCard>
        </Col>
      </Row>
    </>
  );

  // ── Profile Tab (Simplified & Compact: "Show me the learner, not the database") ──
  const ProfileTab = () => (
    <div className="d-flex flex-column gap-3">
      {/* ── Top Header Banner Card ── */}
      <Card
        style={{
          border: '1px solid #E2E8F0',
          borderRadius: 12,
          background: '#ffffff',
          boxShadow: '0 2px 8px rgba(0,0,0,0.03)',
        }}
        className="p-3"
      >
        <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
          <div className="d-flex align-items-center gap-3">
            <div
              style={{ position: 'relative', cursor: 'pointer' }}
              onClick={() => avatarInputRef.current?.click()}
              title="Click to upload profile photo"
            >
              {profilePicSrc ? (
                <img
                  src={profilePicSrc}
                  alt="Avatar"
                  style={{ width: 56, height: 56, borderRadius: '50%', objectFit: 'cover', border: '2px solid #E2E8F0' }}
                />
              ) : (
                <div
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    background: 'linear-gradient(135deg, #00AA87 0%, #00886C 100%)',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '1.4rem',
                    fontWeight: 700,
                  }}
                >
                  {getInitials(userDetails?.fullName)}
                </div>
              )}
              <input ref={avatarInputRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleAvatarChange} />
            </div>

            <div>
              <div className="d-flex align-items-center gap-2">
                <h5 style={{ fontWeight: 700, color: '#0F172A', margin: 0, fontSize: '1.15rem' }}>
                  {userDetails?.fullName || 'Your Name'}
                </h5>
                <span style={{ fontSize: '0.78rem', fontWeight: 600, color: '#00AA87', display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                  <span style={{ width: 7, height: 7, borderRadius: '50%', backgroundColor: '#00AA87', display: 'inline-block' }} /> Active Learner
                </span>
              </div>

              <div style={{ fontSize: '0.82rem', color: '#64748B', marginTop: 2 }}>
                {userDetails?.email} {userDetails?.country ? ` · ${userDetails.country}` : ''}
              </div>
            </div>
          </div>

          {/* Right Action Button */}
          <div>
            {learningIdentity ? (
              <button
                id="see-learning-identity-btn"
                onClick={() => setShowIdentityModal(true)}
                style={{
                  background: 'transparent',
                  border: '1.5px solid #00AA87',
                  color: '#00AA87',
                  borderRadius: 50,
                  padding: '0.35rem 1.1rem',
                  fontSize: '0.82rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.4rem',
                  transition: 'all 0.15s ease',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#00AA87'; e.currentTarget.style.color = '#ffffff'; }}
                onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#00AA87'; }}
              >
                <span>{learningIdentity.badge || '⚡'}</span>
                <span>Learning Identity →</span>
              </button>
            ) : (
              <Badge bg="success" style={{ borderRadius: 50, padding: '0.4rem 0.9rem', fontSize: '0.78rem', textTransform: 'capitalize' }}>
                Learner Profile
              </Badge>
            )}
          </div>
        </div>
      </Card>

      {/* ── 2x2 Grid of Cards ── */}
      <Row className="g-3">
        {/* Top Left: PERSONAL */}
        <Col lg={6}>
          <Card style={{ border: '1px solid #E2E8F0', borderRadius: 12, background: '#ffffff', height: '100%' }}>
            <Card.Header style={{ background: '#ffffff', borderBottom: '1px solid #F1F5F9', padding: '0.75rem 1rem' }} className="d-flex justify-content-between align-items-center">
              <span style={{ fontSize: '0.72rem', fontWeight: 800, color: '#64748B', letterSpacing: '0.6px', textTransform: 'uppercase' }}>PERSONAL</span>
              {!editingProfile ? (
                <button onClick={() => setEditingProfile(true)} style={{ background: 'none', border: 'none', color: '#00AA87', fontSize: '0.78rem', fontWeight: 600, padding: 0, cursor: 'pointer' }}>
                  Edit
                </button>
              ) : (
                <Badge bg="warning" style={{ fontSize: '0.7rem' }}>Editing</Badge>
              )}
            </Card.Header>
            <Card.Body style={{ padding: '0.9rem 1rem' }}>
              {editingProfile ? (
                <Form>
                  <Row className="g-2">
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Full Name</Form.Label>
                        <Form.Control size="sm" style={inputStyle} value={profileForm.fullName} onChange={e => setProfileForm(p => ({ ...p, fullName: e.target.value }))} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Phone</Form.Label>
                        <Form.Control size="sm" style={inputStyle} value={profileForm.phoneNumber} onChange={e => setProfileForm(p => ({ ...p, phoneNumber: e.target.value }))} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Country</Form.Label>
                        <Form.Select size="sm" style={inputStyle} value={profileForm.country} onChange={e => setProfileForm(p => ({ ...p, country: e.target.value }))}>
                          <option value="">Select</option>
                          {AFRICAN_COUNTRIES.map(c => <option key={c}>{c}</option>)}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Location</Form.Label>
                        <Form.Control size="sm" style={inputStyle} placeholder="City/State" value={profileForm.location} onChange={e => setProfileForm(p => ({ ...p, location: e.target.value }))} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Gender</Form.Label>
                        <Form.Select size="sm" style={inputStyle} value={profileForm.gender} onChange={e => setProfileForm(p => ({ ...p, gender: e.target.value }))}>
                          <option value="">Select</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                          <option value="other">Other</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col sm={12}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Bio</Form.Label>
                        <Form.Control as="textarea" rows={2} size="sm" style={{ ...inputStyle, height: 'auto' }} value={profileForm.bio} onChange={e => setProfileForm(p => ({ ...p, bio: e.target.value }))} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="d-flex gap-2 mt-3">
                    <PrimaryBtn size="sm" onClick={handleProfileSave} disabled={profileSaving}>
                      {profileSaving ? 'Saving...' : 'Save'}
                    </PrimaryBtn>
                    <Button variant="light" size="sm" onClick={() => setEditingProfile(false)}>Cancel</Button>
                  </div>
                </Form>
              ) : (
                <Row className="g-3">
                  <Col sm={6}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Full name</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600 }}>{userDetails?.fullName || '—'}</span>
                  </Col>
                  <Col sm={6}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Phone</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600 }}>{userDetails?.phoneNumber || '—'}</span>
                  </Col>
                  <Col sm={6}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Country</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600 }}>{userDetails?.country || '—'}</span>
                  </Col>
                  <Col sm={6}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Location</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600 }}>{userDetails?.location || 'Not added'}</span>
                  </Col>
                  <Col sm={12}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Bio</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 500 }}>{userDetails?.bio || '—'}</span>
                  </Col>
                </Row>
              )}
            </Card.Body>
          </Card>
        </Col>

        {/* Top Right: LEARNING IDENTITY */}
        <Col lg={6}>
          <Card style={{ border: '1px solid #E2E8F0', borderRadius: 12, background: '#ffffff', height: '100%' }}>
            <Card.Header style={{ background: '#ffffff', borderBottom: '1px solid #F1F5F9', padding: '0.75rem 1rem' }} className="d-flex justify-content-between align-items-center">
              <span style={{ fontSize: '0.72rem', fontWeight: 800, color: '#64748B', letterSpacing: '0.6px', textTransform: 'uppercase' }}>LEARNING IDENTITY</span>
              {!editingGoals ? (
                <button onClick={() => setEditingGoals(true)} style={{ background: 'none', border: 'none', color: '#00AA87', fontSize: '0.78rem', fontWeight: 600, padding: 0, cursor: 'pointer' }}>
                  Edit
                </button>
              ) : (
                <Badge bg="warning" style={{ fontSize: '0.7rem' }}>Editing</Badge>
              )}
            </Card.Header>
            <Card.Body style={{ padding: '0.9rem 1rem' }}>
              {editingGoals ? (
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Primary Goal</Form.Label>
                    <div className="d-flex flex-wrap gap-1.5 mt-1">
                      {LEARNING_GOALS.slice(0, visibleGoalsCount).map(g => (
                        <TagChip key={g} selected={goalsForm.primary_goal === g} onClick={() => setGoalsForm(p => ({ ...p, primary_goal: p.primary_goal === g ? '' : g }))}>
                          {g}
                        </TagChip>
                      ))}
                      {visibleGoalsCount < LEARNING_GOALS.length && (
                        <MoreChip onClick={() => setVisibleGoalsCount(c => Math.min(c + PILL_PAGE_SIZE, LEARNING_GOALS.length))}>
                          +{LEARNING_GOALS.length - visibleGoalsCount}
                        </MoreChip>
                      )}
                    </div>
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Target Roles</Form.Label>
                    <Form.Control size="sm" style={inputStyle} placeholder="e.g. Project Management" value={goalsForm.target_roles} onChange={e => setGoalsForm(p => ({ ...p, target_roles: e.target.value }))} />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Target Industries</Form.Label>
                    <div className="d-flex flex-wrap gap-1.5 mt-1">
                      {INDUSTRIES.slice(0, visibleIndustriesCount).map(ind => (
                        <TagChip key={ind} selected={goalsForm.target_industries.includes(ind)} onClick={() => setGoalsForm(p => ({ ...p, target_industries: p.target_industries.includes(ind) ? p.target_industries.filter(i => i !== ind) : [...p.target_industries, ind] }))}>
                          {ind}
                        </TagChip>
                      ))}
                    </div>
                  </Form.Group>
                  <div className="d-flex gap-2 mt-3">
                    <PrimaryBtn size="sm" onClick={handleGoalsSave} disabled={goalsSaving}>
                      {goalsSaving ? 'Saving...' : 'Save'}
                    </PrimaryBtn>
                    <Button variant="light" size="sm" onClick={() => setEditingGoals(false)}>Cancel</Button>
                  </div>
                </Form>
              ) : (
                <div className="d-flex flex-column gap-2.5">
                  <div>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600, marginBottom: 2 }}>Primary Goal</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 700 }}>
                      {learnerProfile.primary_goal ? `🎯 ${learnerProfile.primary_goal}` : '—'}
                    </span>
                  </div>
                  <div>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600, marginBottom: 2 }}>Target role</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600 }}>
                      {Array.isArray(learnerProfile.target_roles) ? learnerProfile.target_roles.join(', ') : (learnerProfile.target_roles || '—')}
                    </span>
                  </div>
                  <div>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600, marginBottom: 2 }}>Target industry</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600 }}>
                      {learnerProfile.target_industries && learnerProfile.target_industries.length > 0
                        ? learnerProfile.target_industries.join(', ')
                        : '—'}
                    </span>
                  </div>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>

        {/* Bottom Left: BACKGROUND */}
        <Col lg={6}>
          <Card style={{ border: '1px solid #E2E8F0', borderRadius: 12, background: '#ffffff', height: '100%' }}>
            <Card.Header style={{ background: '#ffffff', borderBottom: '1px solid #F1F5F9', padding: '0.75rem 1rem' }} className="d-flex justify-content-between align-items-center">
              <span style={{ fontSize: '0.72rem', fontWeight: 800, color: '#64748B', letterSpacing: '0.6px', textTransform: 'uppercase' }}>BACKGROUND</span>
              {!editingSocial ? (
                <button onClick={() => setEditingSocial(true)} style={{ background: 'none', border: 'none', color: '#00AA87', fontSize: '0.78rem', fontWeight: 600, padding: 0, cursor: 'pointer' }}>
                  Edit
                </button>
              ) : (
                <Badge bg="warning" style={{ fontSize: '0.7rem' }}>Editing</Badge>
              )}
            </Card.Header>
            <Card.Body style={{ padding: '0.9rem 1rem' }}>
              {editingSocial ? (
                <Form>
                  <Row className="g-2 mb-2">
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Institution</Form.Label>
                        <Form.Control size="sm" style={inputStyle} value={academicForm.institution} onChange={e => setAcademicForm(p => ({ ...p, institution: e.target.value }))} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Field of Study</Form.Label>
                        <Form.Control size="sm" style={inputStyle} value={academicForm.fieldOfStudy} onChange={e => setAcademicForm(p => ({ ...p, fieldOfStudy: e.target.value }))} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Degree</Form.Label>
                        <Form.Control size="sm" style={inputStyle} value={academicForm.highestDegree} onChange={e => setAcademicForm(p => ({ ...p, highestDegree: e.target.value }))} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Certifications</Form.Label>
                        <Form.Control size="sm" style={inputStyle} value={academicForm.certifications} onChange={e => setAcademicForm(p => ({ ...p, certifications: e.target.value }))} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="d-flex gap-2 mt-3">
                    <PrimaryBtn size="sm" onClick={handleSocialSave} disabled={socialSaving}>
                      {socialSaving ? 'Saving...' : 'Save'}
                    </PrimaryBtn>
                    <Button variant="light" size="sm" onClick={() => setEditingSocial(false)}>Cancel</Button>
                  </div>
                </Form>
              ) : (
                <Row className="g-3">
                  <Col sm={6}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Institution</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600 }}>{academicProfiles.institution || '—'}</span>
                  </Col>
                  <Col sm={6}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Field</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600 }}>{academicProfiles.fieldOfStudy || '—'}</span>
                  </Col>
                  <Col sm={6}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Degree</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600 }}>{academicProfiles.highestDegree || '—'}</span>
                  </Col>
                  <Col sm={6}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Certs</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600 }}>
                      {Array.isArray(academicProfiles.certifications) ? academicProfiles.certifications.join(', ') : (academicProfiles.certifications || '—')}
                    </span>
                  </Col>
                </Row>
              )}
            </Card.Body>
          </Card>
        </Col>

        {/* Bottom Right: LEARNING PREFERENCES */}
        <Col lg={6}>
          <Card style={{ border: '1px solid #E2E8F0', borderRadius: 12, background: '#ffffff', height: '100%' }}>
            <Card.Header style={{ background: '#ffffff', borderBottom: '1px solid #F1F5F9', padding: '0.75rem 1rem' }} className="d-flex justify-content-between align-items-center">
              <span style={{ fontSize: '0.72rem', fontWeight: 800, color: '#64748B', letterSpacing: '0.6px', textTransform: 'uppercase' }}>LEARNING PREFERENCES</span>
              {!editingAvail ? (
                <button onClick={() => setEditingAvail(true)} style={{ background: 'none', border: 'none', color: '#00AA87', fontSize: '0.78rem', fontWeight: 600, padding: 0, cursor: 'pointer' }}>
                  Edit
                </button>
              ) : (
                <Badge bg="warning" style={{ fontSize: '0.7rem' }}>Editing</Badge>
              )}
            </Card.Header>
            <Card.Body style={{ padding: '0.9rem 1rem' }}>
              {editingAvail ? (
                <Form>
                  <Row className="g-2">
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Hours / Week</Form.Label>
                        <Form.Control size="sm" type="number" style={inputStyle} value={availForm.weekly_hours} onChange={e => setAvailForm(p => ({ ...p, weekly_hours: e.target.value }))} />
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Motivation</Form.Label>
                        <Form.Select size="sm" style={inputStyle} value={availForm.motivation_level} onChange={e => setAvailForm(p => ({ ...p, motivation_level: e.target.value }))}>
                          <option value="">Select</option>
                          <option value="low">Low</option>
                          <option value="medium">Medium</option>
                          <option value="high">High</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Device</Form.Label>
                        <Form.Select size="sm" style={inputStyle} value={availForm.device} onChange={e => setAvailForm(p => ({ ...p, device: e.target.value }))}>
                          <option value="">Select</option>
                          <option value="phone">Mobile Phone</option>
                          <option value="pc">PC / Laptop</option>
                          <option value="both">Both</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col sm={6}>
                      <Form.Group>
                        <Form.Label style={{ fontSize: 12, fontWeight: 600 }}>Style</Form.Label>
                        <Form.Select size="sm" style={inputStyle} value={availForm.preferred_learning_style} onChange={e => setAvailForm(p => ({ ...p, preferred_learning_style: e.target.value }))}>
                          <option value="">Select</option>
                          <option value="video">Video</option>
                          <option value="reading">Reading</option>
                          <option value="hands-on">Projects</option>
                          <option value="mixed">Mixed</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="d-flex gap-2 mt-3">
                    <PrimaryBtn size="sm" onClick={handleAvailSave} disabled={availSaving}>
                      {availSaving ? 'Saving...' : 'Save'}
                    </PrimaryBtn>
                    <Button variant="light" size="sm" onClick={() => setEditingAvail(false)}>Cancel</Button>
                  </div>
                </Form>
              ) : (
                <Row className="g-3">
                  <Col sm={6}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Availability</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600 }}>
                      {learnerProfile.weekly_hours ? `${learnerProfile.weekly_hours} hrs/week` : '—'}
                    </span>
                  </Col>
                  <Col sm={6}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Motivation</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600, textTransform: 'capitalize' }}>
                      {learnerProfile.motivation_level || '—'}
                    </span>
                  </Col>
                  <Col sm={6}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Device</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600, textTransform: 'capitalize' }}>
                      {learnerProfile.device || '—'}
                    </span>
                  </Col>
                  <Col sm={6}>
                    <span style={{ fontSize: 11, color: '#94A3B8', display: 'block', fontWeight: 600 }}>Style</span>
                    <span style={{ fontSize: 13.5, color: '#0F172A', fontWeight: 600, textTransform: 'capitalize' }}>
                      {learnerProfile.preferred_learning_style || '—'}
                    </span>
                  </Col>
                </Row>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );

  // ── Courses Tab ──────────────────────────────────────────────────────────
  const CoursesTab = () => (
    <>
      {/* Sub-tab Navigation */}
      <SubTabNav>
        {[
          { key: 'enrolled', icon: <FiBookOpen />, label: `Enrolled (${enrolledList.length + sponsoredList.length})` },
          { key: 'recommended', icon: <FiStar />, label: `Recommended (${recommendedList.length})` },
          { key: 'wishlist', icon: <FiHeart />, label: `Wishlist (${wishlist.length})` },
        ].map(({ key, icon, label }) => (
          <SubTabBtn key={key} active={coursesSubTab === key} onClick={() => setCoursesSubTab(key)}>
            {icon} {label}
          </SubTabBtn>
        ))}
      </SubTabNav>

      {/* Sub-tab Content */}
      {coursesSubTab === 'enrolled' && (
        <SectionCard>
          <Card.Header><FiBookOpen /> My Enrolled & Sponsored Courses</Card.Header>
          <ListGroup variant="flush">
            {[...enrolledList, ...sponsoredList].length > 0 ? (
              [...enrolledList, ...sponsoredList].map(course => {
                const courseUrl = course.link?.startsWith('http') ? course.link : `https://${course.link}`;
                const done = course.status === 'completed';
                const isSponsored = sponsoredList.some(sc => sc.title === course.title);
                return (
                  <StyledListItem key={course._id || course.title} iconColor={done ? brand.success : (isSponsored ? brand.success : brand.warning)}
                    style={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <a
                      href={!done ? courseUrl : undefined}
                      target={!done ? '_blank' : undefined}
                      rel="noopener noreferrer"
                      style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flex: 1, textDecoration: 'none', color: 'inherit', cursor: !done ? 'pointer' : 'default' }}
                      onClick={done ? e => e.preventDefault() : undefined}
                    >
                      <div className="icon-wrap">{isSponsored ? <FiGift /> : <FiBookOpen />}</div>
                      <div className="content">
                        <h6>{course.title}</h6>
                        <p className="text-muted small">
                          {course.description?.length > 60
                            ? `${course.description.slice(0, 60)}...`
                            : course.description}
                        </p>
                        <div className="d-flex gap-2">
                          <StyledBadge className={done ? 'bg-completed' : 'bg-uncompleted'}>
                            {done ? 'Completed' : 'In Progress'}
                          </StyledBadge>
                          {isSponsored && (
                            <StyledBadge className="bg-paid">
                              Sponsored
                            </StyledBadge>
                          )}
                        </div>
                      </div>
                    </a>
                    <div style={{ flexShrink: 0, marginLeft: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                      {done ? (
                        <>
                          {course.completionCertificate && (
                            <PrimaryBtn
                              size="sm"
                              variant="outline-primary"
                              onClick={async () => {
                                try {
                                  const res = await axiosInstance.get(`/dashboard/${course._id}/view-certificate`, { responseType: 'blob' });
                                  window.open(URL.createObjectURL(res.data), '_blank', 'noopener,noreferrer');
                                } catch { toast.error('Could not retrieve certificate.'); }
                              }}
                            >
                              View Cert
                            </PrimaryBtn>
                          )}
                          <PrimaryBtn
                            size="sm"
                            variant="outline-primary"
                            onClick={() => { setReviewCourse(course); setReviewScore(course.rating?.score || 0); setReviewText(course.rating?.review || ''); setShowReviewModal(true); }}
                          >
                            <FiStar size="0.85em" /> {course.rating ? 'Edit Review' : 'Rate'}
                          </PrimaryBtn>
                        </>
                      ) : (
                        <>
                          <PrimaryBtn
                            size="sm"
                            variant="outline-primary"
                            onClick={() => { setSelectedCourse(course); setShowCertModal(true); }}
                          >
                            <FiUpload size="0.85em" /> Upload Cert
                          </PrimaryBtn>
                        </>
                      )}
                      <PrimaryBtn
                        size="sm"
                        variant="outline-primary"
                        onClick={() => loadDiscussion(course)}
                      >
                        <FiMessageSquare size="0.85em" /> Forum
                      </PrimaryBtn>
                    </div>
                  </StyledListItem>
                );
              })
            ) : (
              <ListGroup.Item className="text-center p-5" style={{ border: 'none', background: 'transparent' }}>
                <FiBookOpen size={40} color="var(--border-color)" style={{ marginBottom: '1rem' }} />
                <h6 style={{ color: 'var(--text-secondary)' }}>No enrolled courses yet.</h6>
                <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: '1.5rem' }}>
                  Find a course you'd like to take and request sponsorship to get started.
                </p>
                <Link to="/explore">
                  <PrimaryBtn size="sm">Explore Courses</PrimaryBtn>
                </Link>
              </ListGroup.Item>
            )}
          </ListGroup>
        </SectionCard>
      )}

      {coursesSubTab === 'recommended' && (
        <SectionCard>
          <Card.Header><FiStar /> Recommended Courses</Card.Header>
          <Card.Body className="p-3">
            {recommendedList.length === 0 ? (
              <div className="text-center text-muted py-4">
                <FiTarget size={30} style={{ marginBottom: 10, opacity: 0.4 }} />
                <p style={{ fontSize: 14 }}>
                  No recommendations yet — tell Moji about your goals and we'll match courses to them.
                </p>
                <PrimaryBtn size="sm" onClick={() => setActiveTab('edubuddy')}>
                  <FiMessageCircle size="0.9em" /> Talk to Moji
                </PrimaryBtn>
              </div>
            ) : (
              <Row className="g-3">
                {recommendedList.map(course => {
                  const url = course.link || course.url || '';
                  const href = url.startsWith('http') ? url : `https://${url}`;
                  return (
                    <Col md={4} sm={6} key={course._id || course.title}>
                      <CourseCard>
                        <Card.Body className="d-flex flex-column">
                          <div className="card-title">{course.title}</div>

                          {/* Course Badges: Platform, Level, Price */}
                          <div className="d-flex flex-wrap gap-1 mb-2">
                            {course.platform && (
                              <StyledBadge pill bg="" style={{ backgroundColor: 'rgba(0, 170, 135, 0.1)', color: brand.primary, fontWeight: 600 }}>
                                {course.platform}
                              </StyledBadge>
                            )}
                            {course.level && (
                              <StyledBadge pill bg="" style={{ backgroundColor: '#f1f5f9', color: brand.textSub, fontWeight: 600 }}>
                                <FiBarChart2 size="0.85em" /> {course.level}
                              </StyledBadge>
                            )}
                            {(course.status === 'Free' || course.price === 0 || !course.price) ? (
                              <StyledBadge pill bg="" style={{ backgroundColor: 'rgba(40, 167, 69, 0.12)', color: '#28a745', fontWeight: 600 }}>
                                Free
                              </StyledBadge>
                            ) : (
                              <StyledBadge pill bg="" style={{ backgroundColor: 'rgba(255, 122, 89, 0.12)', color: 'var(--secondary-color)', fontWeight: 600 }}>
                                {course.priceUnit || ''} {course.price}
                              </StyledBadge>
                            )}
                          </div>

                          <p className="card-text mb-3" style={{ flexGrow: 1 }}>
                            {course.description?.length > 90
                              ? `${course.description.slice(0, 90)}...`
                              : course.description || ''}
                          </p>
                          <div className="d-flex flex-column gap-2 mt-auto">
                            <PrimaryBtn
                              size="sm"
                              onClick={() => handleRequestSponsorship(course)}
                              style={{ width: '100%', fontSize: '0.78rem', justifyContent: 'center' }}
                            >
                              <FiGift size="0.85em" /> Request Sponsorship
                            </PrimaryBtn>
                            <div className="d-flex gap-2">
                              {url && (
                                <a href={href} target="_blank" rel="noopener noreferrer" style={{ flex: 1 }}>
                                  <PrimaryBtn size="sm" variant="outline-primary" style={{ width: '100%', fontSize: '0.78rem', justifyContent: 'center' }}>
                                    <FiExternalLink size="0.85em" /> View
                                  </PrimaryBtn>
                                </a>
                              )}
                              <PrimaryBtn
                                size="sm"
                                variant="outline-danger"
                                title="Delete recommendation"
                                onClick={() => handleDeleteCourse(course)}
                                style={{ flex: '0 0 auto', padding: '0.4rem 0.6rem', justifyContent: 'center' }}
                              >
                                <FiTrash2 size="0.85em" />
                              </PrimaryBtn>
                            </div>
                          </div>
                        </Card.Body>
                      </CourseCard>
                    </Col>
                  );
                })}
              </Row>
            )}
          </Card.Body>
        </SectionCard>
      )}

      {coursesSubTab === 'wishlist' && (
        <SectionCard>
          <Card.Header><FiHeart /> My Wishlist</Card.Header>
          <ListGroup variant="flush">
            {wishlist.length > 0 ? (
              wishlist.map(item => (
                <StyledListItem key={item._id} iconColor={brand.primary}>
                  <div className="icon-wrap"><FiHeart /></div>
                  <div className="content" style={{ flex: 1 }}>
                    <h6>{item.title}</h6>
                    <p className="text-muted">
                      {item.platform} &middot; {item.status === 'Free' ? 'Free' : `${item.priceUnit || '$'}${item.price || ''}`}
                    </p>
                  </div>
                  <div className="d-flex gap-2 align-items-center">
                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                      <PrimaryBtn size="sm" variant="outline-primary"><FiExternalLink size="0.85em" /> View</PrimaryBtn>
                    </a>
                    <PrimaryBtn
                      size="sm"
                      variant="outline-danger"
                      onClick={async () => {
                        try {
                          await axiosInstance.delete(`/dashboard/wishlist/${item._id}`);
                          setWishlist(prev => prev.filter(w => w._id !== item._id));
                          toast.success('Removed from wishlist.');
                        } catch {
                          toast.error('Could not remove item.');
                        }
                      }}
                    >
                      <FiTrash2 size="0.85em" />
                    </PrimaryBtn>
                  </div>
                </StyledListItem>
              ))
            ) : (
              <ListGroup.Item className="text-center text-muted p-4">
                Your wishlist is empty. Explore and save courses to your wishlist!
              </ListGroup.Item>
            )}
          </ListGroup>
        </SectionCard>
      )}
    </>
  );

  // ─── Messages Tab ─────────────────────────────────────────────────────────
  const MessagesTab = () => (
    <Row className="g-4">
      {/* Thread list */}
      <Col md={4}>
        <SectionCard style={{ maxHeight: 600, overflowY: 'auto' }}>
          <Card.Header><FiMessageSquare /> Sponsor Messages</Card.Header>
          {msgLoading ? (
            <div className="text-center py-4"><Spinner animation="border" size="sm" style={{ color: brand.primary }} /></div>
          ) : msgThreads.length === 0 ? (
            <div className="text-center text-muted p-4" style={{ fontSize: 13 }}>
              No messages yet. Sponsors who fund your courses can message you here.
            </div>
          ) : (
            <ListGroup variant="flush">
              {msgThreads.map(t => (
                <ListGroup.Item
                  key={t.threadId}
                  action
                  active={selectedThread?.threadId === t.threadId}
                  onClick={() => setSelectedThread(t)}
                  style={{ cursor: 'pointer', padding: '0.9rem 1rem' }}
                >
                  <div style={{ fontWeight: 600, fontSize: 13 }}>{t.sponsor?.fullName || 'Sponsor'}</div>
                  <div style={{ fontSize: 11, color: brand.textSub, marginTop: 2 }}>{t.courseTitle}</div>
                  {t.lastMessage && (
                    <div style={{ fontSize: 11, color: brand.textSub, marginTop: 4, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                      {t.lastMessage.content}
                    </div>
                  )}
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </SectionCard>
      </Col>

      {/* Thread messages + reply */}
      <Col md={8}>
        {!selectedThread ? (
          <SectionCard>
            <Card.Body className="text-center py-5">
              <FiMessageSquare size={40} color={brand.greyMid} style={{ marginBottom: 12 }} />
              <p style={{ color: brand.textSub, fontSize: 14 }}>Select a conversation to read and reply.</p>
            </Card.Body>
          </SectionCard>
        ) : (
          <SectionCard style={{ overflow: 'hidden', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
            <div style={{ backgroundColor: '#fff', borderBottom: '1px solid #E2E8F0', padding: '16px 20px', display: 'flex', alignItems: 'center' }}>
              <h5 style={{ margin: 0, fontWeight: 700, color: '#0F172A', display: 'flex', alignItems: 'center', fontSize: '1.1rem' }}>
                <FiMessageSquare className="me-2" style={{ color: brand.primary }} />
                {selectedThread.sponsor?.fullName} <span style={{ fontWeight: 400, fontSize: '0.9rem', color: '#64748B', marginLeft: '8px' }}>— {selectedThread.courseTitle}</span>
              </h5>
            </div>
            <Card.Body style={{ padding: 0 }}>
              {/* Messages */}
              <div style={{ maxHeight: 380, overflowY: 'auto', backgroundColor: '#F8FAFC', padding: '20px', display: 'flex', flexDirection: 'column' }}>
                {selectedThread.messages.map((msg, idx) => {
                  const isMine = String(msg.senderId) === String(userDetails?._id) ||
                    (msg.senderId?._id && String(msg.senderId._id) === String(userDetails?._id));
                  return (
                    <div key={idx} style={{ display: 'flex', justifyContent: isMine ? 'flex-end' : 'flex-start', marginBottom: 16 }}>
                      <div style={{
                        maxWidth: '75%',
                        padding: '12px 16px',
                        borderRadius: '16px',
                        background: isMine ? brand.primary : '#FFFFFF',
                        color: isMine ? '#fff' : '#334155',
                        fontSize: '0.95rem',
                        lineHeight: 1.5,
                        borderBottomRightRadius: isMine ? 4 : 16,
                        borderBottomLeftRadius: isMine ? 16 : 4,
                        border: isMine ? 'none' : '1px solid #E2E8F0',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
                      }}>
                        <p style={{ margin: 0 }}>{msg.content}</p>
                        <p style={{ margin: '4px 0 0', fontSize: '0.7rem', opacity: isMine ? 0.8 : 0.5, textAlign: isMine ? 'right' : 'left' }}>
                          {msg.timestamp ? new Date(msg.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : ''}
                        </p>
                      </div>
                    </div>
                  );
                })}
                <div ref={msgBottomRef} />
              </div>

              {/* Reply input */}
              <div style={{ padding: '16px 20px', backgroundColor: '#fff', borderTop: '1px solid #E2E8F0' }}>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center', backgroundColor: '#F1F5F9', borderRadius: '24px', padding: '6px 6px 6px 16px' }}>
                  <Form.Control
                    placeholder="Type a reply..."
                    value={replyContent}
                    onChange={e => setReplyContent(e.target.value)}
                    onKeyDown={e => e.key === 'Enter' && !e.shiftKey && handleReply()}
                    style={{ border: 'none', background: 'transparent', boxShadow: 'none', padding: 0, height: 'auto', fontSize: '0.95rem' }}
                  />
                  <button 
                    onClick={handleReply} 
                    disabled={replying || !replyContent.trim()} 
                    style={{ minWidth: 36, height: 36, borderRadius: '50%', backgroundColor: (replying || !replyContent.trim()) ? '#CBD5E1' : brand.primary, color: '#fff', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'background-color 0.2s', cursor: (replying || !replyContent.trim()) ? 'default' : 'pointer' }}
                  >
                    {replying ? <Spinner animation="border" size="sm" /> : <FiSend size={16} style={{ marginLeft: '-2px' }} />}
                  </button>
                </div>
              </div>
            </Card.Body>
          </SectionCard>
        )}
      </Col>
    </Row>
  );

  // ─── Render ───────────────────────────────────────────────────────────────
  return (
    <DashboardWrapper>
      <GlobalStyle />

      {/* Navbar */}
      <SiteNavbar
        hideOnScroll={false}
        containerFluid="lg"
        containerClassName=""
        leftNavDesktop={
          <>
            <Nav.Link as={Link} to="/explore">Explore</Nav.Link>
            <NavDropdown title="Programs" id="programs-dd">
              <NavDropdown.Item as={Link} to="/coming-soon">DAP</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/coming-soon">DigiAccess</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Community" id="community-dd">
              <NavDropdown.Item as={Link} to="/coming-soon">Find learners near you</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/coming-soon">Find mentors near you</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/coming-soon">Join accountability group</NavDropdown.Item>
            </NavDropdown>
          </>
        }
        leftNavMobile={
          <>
            <Nav.Link as={Link} to="/explore">Explore</Nav.Link>
            <NavDropdown title="Programs" id="programs-dd-mobile">
              <NavDropdown.Item as={Link} to="/coming-soon">DAP</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/coming-soon">DigiAccess</NavDropdown.Item>
            </NavDropdown>
            <NavDropdown title="Community" id="community-dd-mobile">
              <NavDropdown.Item as={Link} to="/coming-soon">Find learners near you</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/coming-soon">Find mentors near you</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/coming-soon">Join accountability group</NavDropdown.Item>
            </NavDropdown>
          </>
        }
        rightContent={
          <div className="d-flex align-items-center" style={{ gap: '1.5rem' }}>
            {/* Notification bell (placeholder for learners) */}
            <div style={{ position: 'relative', cursor: 'pointer' }} onClick={() => toast('No new notifications', { icon: '🔔' })}>
              <FiBell size={22} color={brand.sub} />
            </div>
            <PrimaryBtn variant="outline-danger" onClick={handleLogout}>
              <FiLogOut /> Logout
            </PrimaryBtn>
          </div>
        }
      />

      <DashboardContainer fluid="lg">
        {/* Welcome Header */}
        {userDetails && (
          <WelcomeHeader>
            <div>
              {profilePicSrc ? (
                <img src={profilePicSrc} alt="Profile" style={{ width: 64, height: 64, borderRadius: '50%', objectFit: 'cover', border: `3px solid ${brand.primary}` }} />
              ) : (
                <div style={{ background: brand.backgroundLight, padding: '0.75rem', borderRadius: '50%', display: 'inline-flex' }}>
                  <FiUser size={28} color={brand.primary} />
                </div>
              )}
            </div>
            <div>
              <h1>Welcome back, {userDetails.fullName || 'Learner'}!</h1>
              <p>Manage your courses, track progress, and grow your skills.</p>
            </div>
          </WelcomeHeader>
        )}

        {/* Tab Navigation */}
        <TabNav>
          {[
            { key: 'overview', icon: <FiGrid />, label: 'Overview' },
            { key: 'edubuddy', icon: <FiMessageCircle />, label: 'Moji' },
            { key: 'profile', icon: <FiUser />, label: 'My Profile' },
            { key: 'courses', icon: <FiBookOpen />, label: 'Courses & Wishlist' },
            { key: 'messages', icon: <FiMessageSquare />, label: 'Messages' },
          ].map(({ key, icon, label }) => (
            <TabBtn key={key} active={activeTab === key} onClick={() => setActiveTab(key)}>
              {icon} {label}
            </TabBtn>
          ))}
        </TabNav>

        {/* Tab Content */}
        {/* Invoked as plain functions (not JSX elements) so React reconciles
            their output against the previous tree instead of remounting the
            whole subtree (and losing input focus) on every parent re-render. */}
        {activeTab === 'overview' && OverviewTab()}
        {activeTab === 'edubuddy' && (
          <IntakeChatPanel
            initialNotice={claimNotice}
            onProfileChanged={() => setRefreshKey(k => k + 1)}
            onSelectTab={(tabKey) => setActiveTab(tabKey)}
          />
        )}
        {(activeTab === 'profile' || activeTab === 'goals') && ProfileTab()}
        {activeTab === 'courses' && CoursesTab()}
        {activeTab === 'messages' && MessagesTab()}
      </DashboardContainer>



      {/* Learning Identity Modal — triggered from Profile tab */}
      <LearningIdentityModal
        show={showIdentityModal}
        onHide={() => setShowIdentityModal(false)}
        identity={learningIdentity}
        learnerName={userDetails?.fullName}
        onSeeCourses={() => {
          setShowIdentityModal(false);
          setActiveTab('overview');
        }}
      />

      {/* Initial Profile Completion Modal */}
      <CompleteProfileModal
        show={showProfileModal}
        onComplete={({ fullName, path }) => {
          setShowProfileModal(false);
          setUserDetails(prev => ({ ...prev, fullName }));
          setRefreshKey(k => k + 1);
          if (path === 'help') navigate('/help');
          else if (path === 'moji') setActiveTab('edubuddy');
        }}
      />

      {/* ── Review / Rating Modal ─────────────────────────────────── */}
      <StyledModal show={showReviewModal} onHide={() => !reviewSubmitting && setShowReviewModal(false)} centered>
        <Modal.Header closeButton={!reviewSubmitting}>
          <Modal.Title>Rate This Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p style={{ fontSize: 13, color: brand.textSub, marginBottom: '1rem' }}>
            <strong>{reviewCourse?.title}</strong>
          </p>
          <p style={{ fontWeight: 600, marginBottom: '0.5rem', fontSize: 14 }}>Your Rating</p>
          <div className="d-flex gap-2 mb-3">
            {[1, 2, 3, 4, 5].map(s => (
              <button
                key={s}
                onClick={() => setReviewScore(s)}
                style={{
                  background: 'none', border: 'none', cursor: 'pointer', fontSize: 28,
                  color: s <= reviewScore ? '#ffc107' : '#ddd',
                  padding: 0, lineHeight: 1,
                }}
              >
                ★
              </button>
            ))}
            {reviewScore > 0 && (
              <span style={{ fontSize: 13, color: brand.textSub, alignSelf: 'center', marginLeft: 8 }}>
                {['', 'Poor', 'Fair', 'Good', 'Very Good', 'Excellent'][reviewScore]}
              </span>
            )}
          </div>
          <Form.Group>
            <Form.Label style={{ fontSize: 14, fontWeight: 600 }}>Review (optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Share what you learned or what could be improved..."
              value={reviewText}
              onChange={e => setReviewText(e.target.value)}
              style={{ ...inputStyle, height: 'auto', resize: 'none' }}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowReviewModal(false)} disabled={reviewSubmitting}>Cancel</Button>
          <PrimaryBtn onClick={handleSubmitReview} disabled={reviewSubmitting || !reviewScore}>
            {reviewSubmitting ? <><Spinner animation="border" size="sm" className="me-1" /> Submitting...</> : 'Submit Review'}
          </PrimaryBtn>
        </Modal.Footer>
      </StyledModal>

      {/* ── Discussion Forum Modal ─────────────────────────────────── */}
      <StyledModal show={showDiscModal} onHide={() => setShowDiscModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title><FiMessageSquare className="me-2" />{discCourse?.title} — Discussion</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
          {discLoading ? (
            <div className="text-center py-4"><Spinner animation="border" style={{ color: brand.primary }} /></div>
          ) : discPosts.length === 0 ? (
            <div className="text-center text-muted py-4">
              <FiMessageSquare size={32} style={{ marginBottom: 8 }} />
              <p>No posts yet. Be the first to start a discussion!</p>
            </div>
          ) : (
            discPosts.map((post, idx) => (
              <div key={post._id || idx} style={{ background: brand.backgroundLight, borderRadius: 10, padding: '0.75rem 1rem', marginBottom: '0.75rem', borderLeft: `3px solid ${brand.primary}` }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                  <div style={{ width: 28, height: 28, borderRadius: '50%', background: brand.primary, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <FiUser size={14} color="#fff" />
                  </div>
                  <span style={{ fontWeight: 600, fontSize: 13, color: brand.text }}>
                    {post.userId?.fullName || 'Learner'}
                  </span>
                  <span style={{ fontSize: 11, color: brand.textSub, marginLeft: 'auto' }}>
                    {new Date(post.createdAt).toLocaleDateString()}
                  </span>
                </div>
                <p style={{ margin: 0, fontSize: 13, color: brand.text, lineHeight: 1.6 }}>{post.message}</p>
              </div>
            ))
          )}
        </Modal.Body>
        <Modal.Footer style={{ flexDirection: 'column', gap: 8 }}>
          <div style={{ display: 'flex', gap: 8, width: '100%' }}>
            <Form.Control
              placeholder="Write a message to the forum..."
              value={discMessage}
              onChange={e => setDiscMessage(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && !e.shiftKey && handlePostDiscussion()}
              style={{ ...inputStyle, height: 42, flex: 1 }}
              disabled={discPosting}
            />
            <PrimaryBtn onClick={handlePostDiscussion} disabled={discPosting || !discMessage.trim()} style={{ minWidth: 90 }}>
              {discPosting ? <Spinner animation="border" size="sm" /> : <><FiSend size="0.9em" /> Post</>}
            </PrimaryBtn>
          </div>
        </Modal.Footer>
      </StyledModal>

      {/* ── Moji Moji ─────────────────────────────────────────── */}
      <MojiChatbot />

      {/* Certificate Upload Modal */}
      {selectedCourse && (
        <StyledModal show={showCertModal} onHide={() => !isUploading && setShowCertModal(false)} centered>
          <Modal.Header closeButton={!isUploading}>
            <Modal.Title>Upload Certificate</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p style={{ fontSize: 13, color: brand.textSub, marginBottom: '1rem' }}>
              Course: <strong>{selectedCourse.title}</strong>
            </p>
            {isUploading ? (
              <div className="text-center py-3">
                <Spinner animation="border" variant="success" />
                <p className="mt-2 mb-0 text-muted">Uploading...</p>
              </div>
            ) : (
              <Form.Group>
                <Form.Label>Select file (PDF, JPG, PNG — max 512 KB)</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  onChange={e => {
                    const file = e.target.files[0];
                    if (file && file.size > 512 * 1024) {
                      toast.error('File must not exceed 512 KB.');
                      e.target.value = '';
                      setSelectedFile(null);
                    } else {
                      setSelectedFile(file);
                    }
                  }}
                />
              </Form.Group>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="light" onClick={() => setShowCertModal(false)} disabled={isUploading}>Cancel</Button>
            <PrimaryBtn onClick={handleUploadCertificate} disabled={!selectedFile || isUploading}>
              {isUploading ? 'Uploading...' : 'Upload Certificate'}
            </PrimaryBtn>
          </Modal.Footer>
        </StyledModal>
      )}

      {/* Course Detail Modal */}
      {selectedCatCourse && (
        <StyledModal show={!!selectedCatCourse} onHide={() => setSelectedCatCourse(null)} centered size="md">
          <Modal.Header closeButton>
            <Modal.Title>{selectedCatCourse.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex gap-2 flex-wrap mb-3">
              <Badge bg={selectedCatCourse.status === 'Free' ? 'success' : 'warning'} style={{ borderRadius: 50 }}>
                {selectedCatCourse.status === 'Free' ? 'Free' : `${selectedCatCourse.priceUnit || '$'}${selectedCatCourse.price || ''}`}
              </Badge>
              {selectedCatCourse.level && <Badge bg="secondary" style={{ borderRadius: 50 }}>{selectedCatCourse.level}</Badge>}
              {selectedCatCourse.platform && <Badge bg="light" text="dark" style={{ borderRadius: 50 }}>{selectedCatCourse.platform}</Badge>}
            </div>
            <p style={{ color: brand.textSub, fontSize: 14 }}>{selectedCatCourse.description || 'No description available.'}</p>
            {selectedCatCourse.ratings && (
              <p style={{ marginBottom: '0.5rem' }}>
                <FiStar style={{ color: '#ffc107' }} /> Rating: <strong>{selectedCatCourse.ratings}/5</strong>
              </p>
            )}
            {selectedCatCourse.tags?.length > 0 && (
              <div className="d-flex flex-wrap gap-1 mt-2">
                {selectedCatCourse.tags.map(t => (
                  <Badge key={t} bg="light" text="dark" style={{ borderRadius: 50, border: '1px solid #ddd' }}>{t}</Badge>
                ))}
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <a href={selectedCatCourse.url} target="_blank" rel="noopener noreferrer">
              <PrimaryBtn variant="outline-primary"><FiExternalLink /> View Course</PrimaryBtn>
            </a>
            {selectedCatCourse.status === 'Free' ? (
              <PrimaryBtn
                disabled={
                  dashboardCourses.some(dc => dc.title === selectedCatCourse.title) ||
                  enrollingId === selectedCatCourse._id
                }
                onClick={() => { setSelectedCatCourse(null); handleEnroll(selectedCatCourse); }}
              >
                {enrollingId === selectedCatCourse._id
                  ? <><Spinner animation="border" size="sm" className="me-1" /> Enrolling...</>
                  : dashboardCourses.some(dc => dc.title === selectedCatCourse.title)
                    ? 'Already Enrolled'
                    : 'Enroll Free'}
              </PrimaryBtn>
            ) : (
              <Button
                variant="warning"
                style={{ borderRadius: 50, fontWeight: 600 }}
                onClick={() => navigate('/help', {
                  state: {
                    course: {
                      courseTitle: selectedCatCourse.title,
                      platform: selectedCatCourse.platform,
                      link: selectedCatCourse.url,
                      price: selectedCatCourse.price,
                      priceUnit: selectedCatCourse.priceUnit,
                    },
                  },
                })}
              >
                Get Sponsored
              </Button>
            )}
          </Modal.Footer>
        </StyledModal>
      )}
    </DashboardWrapper>
  );
};

export default LearnerDashboard;
